import { DOCUMENT } from '@angular/common';
import { EventEmitter, Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DEFAULT_LANGUAGE } from '@models/system';

@Injectable({ providedIn: 'root' })
export class LocaleService {
  private readonly document = inject(DOCUMENT);
  private readonly translate = inject(TranslateService);

  locale: string;
  localeChanged = new EventEmitter<string>();

  constructor() {
    this.locale = this.translate.getCurrentLang() || DEFAULT_LANGUAGE;
    this.setLocale(this.locale);

    this.translate.onLangChange.subscribe(ev => {
      this.locale = ev.lang;
      this.syncDocumentLang(ev.lang);
      this.localeChanged.emit(this.locale);
    });
  }

  setLocale(locale: string) {
    this.translate.use(locale);
    this.syncDocumentLang(locale);
  }

  getLocale(): string {
    return this.locale;
  }

  // WCAG 3.1.1 — keep <html lang> in sync with the active translation so
  // screen readers select the correct pronunciation rules.
  private syncDocumentLang(locale: string): void {
    if (locale) {
      this.document.documentElement.lang = locale;
    }
  }
}
